import { isDebug } from '../helpers/utils';
import amaLog from '../helpers/log';
import { withinTopScrollerHourlyLimit } from '../config/adslots';
import { timeFor } from '../helpers/time';
import waitFor from '../helpers/waitfor';


interface GPTEvent {
  slot: {
    getSlotElementId: () => string;
  };
  advertiserId?: string;
  campaignId?: string;
  creativeId?: string;
  isEmpty?: boolean;
  lineItemId?: string;
  size?: string;
  sourceAgnosticCreativeId?: string;
  sourceAgnosticLineItemId?: string;
  inViewPercentage?: number;
}

export const checkTopAdsLoaded = (placementId: string) => {
  window.googletag?.pubads()?.addEventListener('slotRenderEnded', (event: GPTEvent) => {
    if (event.slot.getSlotElementId() !== placementId) return;

    if (event.isEmpty) {
      amaLog(`No ad loaded for slot #${placementId}`);
    } else {
      withinTopScrollerHourlyLimit(true);
      amaLog(`Ad loaded successfully for slot #${placementId}`);
    }
  });
};

// ToDo: Build separate script for GPT event debugging
const initGptDebugging = () => {
  if (isDebug()) {
    window.googletag.pubads().addEventListener('impressionViewable', (event: GPTEvent) => {
      const slotId = event.slot.getSlotElementId();
      amaLog(`Impression for slot ${slotId} became viewable.`);
    });

    window.googletag.pubads().addEventListener('slotOnload', (event: GPTEvent) => {
      const slotId = event.slot.getSlotElementId();
      amaLog(`Creative iframe for slot ${slotId} has loaded.`);
    });

    window.googletag.pubads().addEventListener('slotRenderEnded', (event: GPTEvent) => {
      const slotId = event.slot.getSlotElementId();
      console.group(`Slot ${slotId} finished rendering.`);
      amaLog('Advertiser ID:', event.advertiserId);
      amaLog('Campaign ID:', event.campaignId);
      amaLog('Creative ID:', event.creativeId);
      amaLog('Is empty?:', event.isEmpty);
      amaLog('Line Item ID:', event.lineItemId);
      amaLog('Size:', event.size);
      amaLog('Source Agnostic Creative ID:', event.sourceAgnosticCreativeId);
      amaLog('Source Agnostic Line Item ID:', event.sourceAgnosticLineItemId);
      console.groupEnd();
    });

    window.googletag.pubads().addEventListener('slotRequested', (event: GPTEvent) => {
      const slotId = event.slot.getSlotElementId();
      amaLog(`Slot ${slotId} has been requested.`);
    });

    window.googletag.pubads().addEventListener('slotResponseReceived', (event: GPTEvent) => {
      const slotId = event.slot.getSlotElementId();
      amaLog(`Ad response for slot ${slotId} received.`);
    });

    window.googletag.pubads().addEventListener('slotVisibilityChanged', (event: GPTEvent) => {
      const slotId = event.slot.getSlotElementId();
      console.group(`Visibility of slot ${slotId} changed.`);
      amaLog(`Visible area: ${event.inViewPercentage}%`);
      console.groupEnd();
    });
  }
};
/**
 * Configure GPT with new API, with fallback for older versions.
 */
const applyGPTBaseConfig = () => {

  window.googletag.setConfig({
    collapseDiv: 'ON_NO_FILL',
    disableInitialLoad: true,
  });
};

const initGpt = async () => {
  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];

  amaLog('initGpt', timeFor('gptCmd'));

  window.googletag.cmd.push(() => {
    amaLog('window.googletag.cmd active', timeFor('gptCmd'), window.googletag?.pubadsReady);
    
    applyGPTBaseConfig();
    window.googletag.enableServices();
  });
  await waitFor(() => window.googletag.pubadsReady === true);

  amaLog('initGPT DONE');
};

export const clearSlots = () => {
   // destroy all existing gpt slots

   if (typeof window.googletag === 'object' && typeof window.googletag.destroySlots === 'function') {
    window.googletag.destroySlots();
    amaLog('clearSlots DONE');  
  }
};


export default initGpt;
